var _circle, _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    stroke: "#B6B8D5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.5C10.25 9.48675 9.87265 11.2488 9.29524 12.4861C8.6894 13.7844 8.00202 14.25 7.5 14.25C6.99798 14.25 6.3106 13.7844 5.70476 12.4861C5.12735 11.2488 4.75 9.48675 4.75 7.5C4.75 5.51325 5.12735 3.75118 5.70476 2.51386C6.3106 1.21564 6.99798 0.75 7.5 0.75C8.00202 0.75 8.6894 1.21564 9.29524 2.51386C9.87265 3.75118 10.25 5.51325 10.25 7.5Z",
    stroke: "#B6B8D5",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.75,
    x2: 14,
    y2: 4.75,
    stroke: "#B6B8D5",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 9.75,
    x2: 14,
    y2: 9.75,
    stroke: "#B6B8D5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBrowser);
export default __webpack_public_path__ + "static/media/icn-browser.fd741a6e72b0bc7a807648d3342e1203.svg";
export { ForwardRef as ReactComponent };